export default __webpack_public_path__ + "static/media/FB4.55300bf5.png";